import { LOCALES } from '../locales';

const en = {
    [LOCALES.ENGLISH]: {
        'title': 'Boilerplate',
        'welcome': 'Welcome'
    }
}
export default en;